<script>
/* MIXINS */
import permissionsMixin from '@mixins/permissionsMixin';
import messageMixin from '@mixins/messageMixin';

export default {
  mixins: [permissionsMixin, messageMixin],
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    displayTitle() {
      return this.title ?? this.$t('ota_items_debug.title');
    },
    hasItems() {
      return this.items != null && this.items.length > 0;
    },
  },
  methods: {
    async copyExternalId(externalId) {
      await navigator.clipboard.writeText(externalId);
      this.success(this.$t('externalId copié'));
    },
  },
};
</script>
<template>
  <div v-if="isGasGav() && hasItems" class="flex flex-col gap-1">
    <span class="font-inter font-semibold text-grey-900 text-base">{{ displayTitle }}</span>
    <div
      v-for="otaItem in items"
      :key="otaItem.tableName + otaItem.platform + otaItem.externalId"
      class="font-medium text-sm text-grey-400 flex flex-col w-fit">
      {{ otaItem.platform }} · {{ otaItem.tableName }}
      <span
        class="text-grey-500 bg-grey-100/70 w-fit font-mono font-medium text-sm rounded-sm pl-2 pr-1 py-0.5 flex items-center gap-1">
        {{ otaItem.externalId }}
        <button
          @click="copyExternalId(otaItem.externalId)"
          @keydown.enter="copyExternalId(otaItem.externalId)"
          class="p-1 text-grey-500 hover:bg-grey-50 rounded-sm cursor-pointer hover:text-grey-600 active:text-grey-800">
          <i class="ga-icon text-sm ga-copy" />
        </button>
      </span>
    </div>
  </div>
</template>
